export class TeAutosaveCookieDto {
    id: number;
    alias?: string;
    content?: string;
    timeStamp?: number;
}